import showErrorPopup from  '../popups/error';

export default function initHomepageLoadMoreProperties( container, actionsContainer ) {
    var url = container.dataset.featuredActionUrl;
    var props = [];
    container.querySelectorAll( 'div[data-property-id]' ).forEach( function( el ) {
        props.push( el.dataset.propertyId );
    } );
    var excludedIds = props.join( ',' );
    http( url + '?excludedIds=' + excludedIds )
        .then( function( response ) {
            return response.text();
        } )
        .then( function( html ) {
            var range = document.createRange();
            range.selectNode( actionsContainer );
            var fragment = range.createContextualFragment( html );

            if ( fragment.querySelectorAll( 'div[data-property-id]' ).length < 4 ) {
                actionsContainer.classList.add( 'd-none' );
            }

            actionsContainer.appendChild( fragment );

            document.dispatchEvent( new CustomEvent( 'twc:newcontentloaded', {
                detail: {
                    container: document,
                },
                bubbles: true,
            } ) );
        } )
        .catch( showErrorPopup );
}
